(function () {
  'use strict';

  /* @ngdoc object
   * @name events.guests.view
   * @description
   *
   */
  angular
    .module('events.guests.view', [
      'ui.router'
    ]);
}());
